import { Map } from 'immutable';

import * as types from './types';


const initialState = Map({
  loading: true,
});

const authReducer = (state = initialState, { type }) => {
  switch (type) {
    case types.INITIALIZE.SUCCESS:
    case types.INITIALIZE.FAILURE: // It will failure on /api/whoami call for unauthenticated user
      return state.set('loading', false);
    default:
      return state;
  }
};

export default authReducer;
export { initialState };
